import template from './topdata-contact-login-list.html.twig';
import './topdata-contact-login-list.scss';

const { Mixin, Classes } = Shopware;
const { Criteria } = Shopware.Data;

const DUPLICATE_EMAIL_CODE = 'VIOLATION::CUSTOMER_EMAIL_NOT_UNIQUE';

Shopware.Component.register('topdata-contact-login-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('notification'),
        Mixin.getByName('listing'),
    ],

    data() {
        return {
            items: null,
            isLoading: false,
            sortBy: 'createdAt',
            sortDirection: 'DESC',
            naturalSorting: false,
            total: 0,
            showContactModal: false,
            showConvertModal: false,
            currentContact: null,
            contactEmailError: null,
            salutations: [],
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdcl_customer_contact');
        },

        salutationRepository() {
            return this.repositoryFactory.create('salutation');
        },

        columns() {
            return [
                {
                    property: 'email',
                    label: this.$tc('TopdataContactLoginSW6.admin.email'),
                    allowResize: true,
                    primary: true,
                },
                {
                    property: 'firstName',
                    label: this.$tc('TopdataContactLoginSW6.contactList.list.column.name'),
                    allowResize: true,
                },
                {
                    property: 'customer',
                    label: this.$tc('TopdataContactLoginSW6.contactList.list.column.customer'),
                    allowResize: true,
                },
                {
                    property: 'active',
                    label: this.$tc('TopdataContactLoginSW6.admin.status'),
                    allowResize: true,
                    width: '80px',
                },
                {
                    property: 'createdAt',
                    label: this.$tc('TopdataContactLoginSW6.contactList.list.column.createdAt'),
                    allowResize: true,
                },
            ];
        },
    },

    created() {
        this.loadSalutations();
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.setTerm(this.term);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));
            criteria.addAssociation('customer');

            return this.repository.search(criteria, Shopware.Context.api).then((result) => {
                this.items = result;
                this.total = result.total;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        getContactName(contact) {
            return `${contact.firstName} ${contact.lastName}`.trim();
        },

        getCustomerLabel(item) {
            if (!item.customer) {
                return '—';
            }
            const name = `${item.customer.firstName} ${item.customer.lastName}`.trim();
            return item.customer.customerNumber
                ? `${name} (${item.customer.customerNumber})`
                : name;
        },

        openCustomer(customerId) {
            if (customerId) {
                this.$router.push({ name: 'sw.customer.detail', params: { id: customerId } });
            }
        },

        openContact(contact) {
            if (!contact || !contact.id) {
                return;
            }

            this.$router.push({
                name: 'topdata.contact.login.detail',
                params: { id: contact.id },
            });
        },

        loadSalutations() {
            const criteria = new Criteria();
            this.salutationRepository.search(criteria, Shopware.Context.api)
                .then((result) => {
                    this.salutations = result;
                });
        },

        onEditContact(contact) {
            this.contactEmailError = null;
            this.currentContact = contact;
            this.showContactModal = true;
        },

        onDeleteContact(contact) {
            this.$refs.contactDeleteModal.showDeleteModal(contact);
        },

        onConfirmDeleteContact(contact) {
            this.isLoading = true;

            this.repository.delete(contact.id, Shopware.Context.api)
                .then(() => {
                    this.getList();
                    this.createNotificationSuccess({
                        message: this.$tc('TopdataContactLoginSW6.admin.contactDeleted'),
                    });
                })
                .catch(() => {
                    this.isLoading = false;
                    this.createNotificationError({
                        message: this.$tc('TopdataContactLoginSW6.admin.contactDeleteError'),
                    });
                });
        },

        onSaveContact() {
            this.isLoading = true;

            this.repository.save(this.currentContact, Shopware.Context.api)
                .then(() => {
                    this.contactEmailError = null;
                    this.showContactModal = false;
                    this.getList();
                    this.createNotificationSuccess({
                        message: this.$tc('TopdataContactLoginSW6.admin.contactSaved'),
                    });
                })
                .catch((exception) => {
                    this.isLoading = false;
                    this.handleSaveError(exception);
                });
        },

        handleSaveError(exception) {
            const errors = exception && exception.response && exception.response.data
                ? exception.response.data.errors
                : [];

            const emailViolation = errors.find((error) => (
                error.code === DUPLICATE_EMAIL_CODE
                || (error.source && error.source.pointer === '/email')
            ));

            if (emailViolation) {
                this.contactEmailError = new Classes.ShopwareError({
                    code: DUPLICATE_EMAIL_CODE,
                    detail: this.$tc('TopdataContactLoginSW6.admin.contactEmailNotUnique'),
                });

                this.createNotificationError({
                    message: this.$tc('TopdataContactLoginSW6.admin.contactEmailNotUnique'),
                });

                return;
            }

            this.contactEmailError = null;
            this.createNotificationError({
                message: this.$tc('TopdataContactLoginSW6.admin.contactSaveError'),
            });
        },

        onCloseModal() {
            this.contactEmailError = null;
            this.showContactModal = false;
            this.currentContact = null;
        },

        onOpenConvertModal() {
            this.showConvertModal = true;
        },

        onCloseConvertModal() {
            this.showConvertModal = false;
        },

        onConversionSuccess(data) {
            this.showConvertModal = false;
            this.getList();

            this.createNotificationSuccess({
                message: this.$tc(
                    'TopdataContactLoginSW6.admin.convertCustomerSuccess',
                    0,
                    { count: data.ordersTransferred }
                ),
            });
        },

        onConversionError(errorMessage) {
            this.createNotificationError({
                message: this.$tc('TopdataContactLoginSW6.admin.convertCustomerError') + ': ' + errorMessage,
            });
        }
    },
});